<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="table.where" label-width="77px" class="ele-form-search" @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :md="10" :sm="12">
            <el-form-item label="日期范围:">
              <el-date-picker
                v-model="daterange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                class="ele-fluid"
                @change="onDateRangeChoose"
              />
            </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询 </el-button>
              <el-button
                @click="
                  (table.where = {
                    startTime: $util.toDateString(new Date(), 'yyyy-MM-dd 00:00:00'),
                    endTime: $util.toDateString(new Date(), 'yyyy-MM-dd 23:59:59'),
                  }) && $refs.table.reload()
                "
                >重置</el-button
              >
              <el-button @click="exportData" type="primary" icon="el-icon-download" class="ele-btn-icon">导出 </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 数据表格 -->
      <ele-data-table ref="table" :config="table" :choose.sync="choose" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column header-align="center" prop="goodsName" align="center" label="物品" />
          <el-table-column header-align="center" prop="address" align="center" label="地点" />
          <el-table-column header-align="center" prop="content" align="center" label="报修内容" />
          <el-table-column header-align="center" prop="img" align="center" label="图片">
            <template #default="{ row }">
              <el-tag :type="row.img ? '' : 'info'" @click="showImage(row)">{{ row.img ? '预览' : '暂无' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column header-align="center" prop="createTime" align="center" label="报修时间" />
          <el-table-column header-align="center" prop="reportUserName" align="center" label="报修人" />
          <el-table-column header-align="center" prop="handleTime" align="center" label="处理时间" />
          <el-table-column header-align="center" prop="handlerUserName" align="center" label="处理人" />
          <el-table-column header-align="center" align="center" label="状态">
            <template #default="{ row }">
              <el-tag :type="row.state == 0 ? 'info' : row.state == 1 ? '' : 'success'">{{
                row.state == 0 ? '待处理' : row.state == 1 ? '处理中' : '已完成'
              }}</el-tag>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
      <!-- 图片预览弹窗 -->
      <el-dialog title="物品图片" :visible.sync="showImg" width="30%" :destroy-on-close="true" :lock-scroll="false" :close-on-click-modal="false">
        <el-image :src="img" fit="contain" width="150px" />
        <span slot="footer" class="dialog-footer">
          <el-button @click="showImg = false">取 消</el-button>
          <el-button type="primary" @click="showImg = false">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
  import { exportRepair } from '@/config/api';

  export default {
    name: 'Record',
    data() {
      return {
        table: {
          // 表格配置
          url: '/school/repair/list',
          where: {
            startTime: this.$util.toDateString(new Date(), 'yyyy-MM-dd 00:00:00'),
            endTime: this.$util.toDateString(new Date(), 'yyyy-MM-dd 23:59:59'),
          },
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        choose: [], // 表格选中数据
        daterange: [new Date(), new Date()],
        showImg: false,
        img: '',
      };
    },
    methods: {
      onDateRangeChoose() {
        if (this.daterange) {
          this.table.where.startTime = this.$util.toDateString(this.daterange[0], 'yyyy-MM-dd 00:00:00');
          this.table.where.endTime = this.$util.toDateString(this.daterange[1], 'yyyy-MM-dd 23:59:59');
        } else {
          this.table.where.startTime = null;
          this.table.where.endTime = null;
        }
      },
      // 预览图片
      showImage(row) {
        if (row.img) {
          this.showImg = true;
          this.img = row.img;
        } else {
          return false;
        }
      },
      exportData() {
        if (this.daterange) {
          let data = {
            startTime: this.$util.toDateString(this.daterange[0], 'yyyy-MM-dd 00:00:00'),
            endTime: this.$util.toDateString(this.daterange[1], 'yyyy-MM-dd 23:59:59'),
          };
          exportRepair(data).then((res) => {
            let blob = new Blob([res.data], {
              type: 'application/octet-stream',
            });
            let objectUrl = URL.createObjectURL(blob);
            // console.log(objectUrl)
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = objectUrl;
            let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
            // console.log(res.headers)
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            // console.log(link);
            link.click();
            document.body.removeChild(link); // 下载完成移除元素
            window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
          });
        }
      },
    },
  };
</script>

<style scoped></style>
